function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 7.19L16.811 3a1.5 1.5 0 00-2.121 0l-2.47 2.47-8.78 8.78A1.49 1.49 0 003 15.31v4.19A1.502 1.502 0 004.5 21h4.19a1.49 1.49 0 001.06-.44L21 9.31a1.502 1.502 0 000-2.12zm-3 3L13.811 6l1.94-1.94 4.189 4.19z",
    fill: props.fill
  }));
}

export default SvgPencil;